import {keyMirror} from 'utils/DBUtils';

export const ActionTypes = keyMirror({
  OPEN_PRIZE_CHALLENGES_MODAL: null,
  CLOSE_PRIZE_CHALLENGES_MODAL: null
});

export const openPrizeChallengesModal = prizeId => ({
  type: ActionTypes.OPEN_PRIZE_CHALLENGES_MODAL,
  prizeId
});

export const closePrizeChallengesModal = () => ({
  type: ActionTypes.CLOSE_PRIZE_CHALLENGES_MODAL
});



// WEBPACK FOOTER //
// ./public/components/PrizeChallengesModal/actions.js